import React, { useEffect, useState } from 'react';
import { Typography, ListItemText, ListItemButton } from '@mui/material';
import PropTypes from 'prop-types';
import io from 'socket.io-client';

import Iconify from '../../../components/iconify';
import axiosInstance from '../../../api';
import SERVER_API_URL from '../../../config';

export default function ChurchSideBar({ churchQuery, handleSearch, targetId, userId }) {
  const [churchList, setChurchList] = useState([]);
  const [filteredChurch, setFilteredChurch] = useState([]);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const getAllChurch = async () => {
      try {
        const response = await axiosInstance.post(`${SERVER_API_URL}/church/findChatSideBar/${userId}`);

        if (response.status === 200) {
          setChurchList(response.data);
          setFilteredChurch(response.data);
        }
      } catch (error) {
        // console.log(error);
      }
    };

    getAllChurch();
  }, [userId, setChurchList, setFilteredChurch]);

  useEffect(() => {
    const allChurch = churchList;
    setFilteredChurch(
      churchQuery
        ? allChurch.filter((church) => church.name.toLowerCase().includes(churchQuery.toLowerCase()))
        : allChurch
    );
  }, [churchQuery, churchList]);

  useEffect(() => {
    const newSocket = io(`${SERVER_API_URL}`, { transports: ['websocket'] });
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (socket) {
      socket.on('onMessage', (newMessage) => {
        if (newMessage.target.churchId !== targetId) {
          setChurchList((prevChurches) =>
            prevChurches.map((church) =>
              church.id === newMessage.target.churchId ? { ...church, unreadCounter: church.unreadCounter + 1 } : church
            )
          );
        }
      });
    }

    return () => {
      if (socket) {
        socket.off('onMessage');
      }
    };
  }, [socket, targetId]);

  const handleRead = (churchId) => {
    setChurchList((prevChurches) =>
      prevChurches.map((church) => (church.id === churchId ? { ...church, unreadCounter: 0 } : church))
    );
  };

  return (
    filteredChurch &&
    filteredChurch.map((church) => (
      <ListItemButton
        key={church.id}
        onClick={() => {
          handleSearch(church.id, church.name);
          handleRead(church.id);
        }}
        sx={{
          py: 1.5,
          px: 2.5,
          mt: '1px',
          ...(church.id === targetId && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        <ListItemText
          primary={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <Iconify icon="noto:church" sx={{ mr: 0.5, ml: 0.5, width: 16, height: 16 }} />
                {church.name}
              </span> 
              {church?.unreadCounter > 0 && (
              <span style={{ color: '#2065d1', backgroundColor: '#cde7e9', borderRadius: "50%", padding: '1px 2px', textAlign: 'center' }}>
                {church.unreadCounter}
              </span>
              )}
            </div>
          }
          secondary={
            <Typography
              variant="caption"
              sx={{
                mt: 0.5,
                display: 'flex',
                alignItems: 'center',
                color: 'text.disabled',
              }}
            >
              በዚህ {church.type} ውስጥ {church.users.length} ተከታዮች
            </Typography>
          }
        />
      </ListItemButton>
    ))
  );
}

ChurchSideBar.propTypes = {
  churchQuery: PropTypes.string,
  handleSearch: PropTypes.func,
  targetId: PropTypes.string,
  userId: PropTypes.string,
};
